import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault(); // Prevent page reload
    setStatus('Sending...');

    emailjs.send(
      '',    // e.g., ''
      '',   // e.g., 'template_abc123'
      formData,             // { name, email, message }
      ''     // e.g., ''
    )
    .then((response) => {
      console.log('Success:', response); // For debugging
      setStatus('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' }); // Clear form
    })
    .catch((error) => {
      console.error('Error:', error); // For debugging
      setStatus('Failed to send. Please try again or check console for details.');
    });
  };

  return (
    <div style={{ backgroundColor: 'var(--bg-primary)', minHeight: '100vh', padding: '4rem 1rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>Contact</h1>
      <p style={{ fontSize: '1.2rem', color: 'var(--text-muted)', marginBottom: '2rem' }}>
        Reach out for collaborations, questions, or opportunities.
      </p>
      <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'left' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Contact Information</h2>
        <ul style={{ listStyleType: 'none', padding: 0, color: '#9CA3AF' }}>
          <li><strong>Email:</strong> <a href="mailto:hazim@gmail.com" style={{ color: 'var(--accent)' }}>hazim@gmail.com</a></li>
          <li><strong>Phone:</strong> (+92) 3175252552</li>
          <li><strong>Address:</strong> Village Tarujabba Tehsil Pabbi District Nowshera, 24310, Pakistan</li>
        </ul>
        
        <h2 style={{ fontSize: '1.8rem', margin: '2rem 0 1rem' }}>Send a Message</h2>
        <form onSubmit={sendEmail} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <input 
            type="text" 
            name="name"
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            required
            style={{ padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--card-bg)', color: 'var(--text-main)' }} 
          />
          <input 
            type="email" 
            name="email"
            placeholder="Your Email" 
            value={formData.email}
            onChange={handleChange}
            required
            style={{ padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--card-bg)', color: 'var(--text-main)' }} 
          />
          <textarea 
            name="message"
            placeholder="Your Message" 
            rows="5" 
            value={formData.message}
            onChange={handleChange}
            required
            style={{ padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--card-bg)', color: 'var(--text-main)' }} 
          />
          <button 
            type="submit" 
            style={{ 
              backgroundColor: 'var(--accent)', 
              color: '#FFFFFF', 
              padding: '0.75rem', 
              border: 'none', 
              borderRadius: '12px', 
              cursor: 'pointer', 
              fontSize: '1rem' 
            }}
          >
            Send Message
          </button>
        </form>
        {status && <p style={{ marginTop: '1rem', color: status.includes('Failed') ? 'red' : 'green', fontWeight: 'bold' }}>{status}</p>}
      </div>
    </div>
  );
};

export default Contact;
